import React from 'react'

export default function Slide({ src }) {
    return (
        <img src={src} alt="slide-img" className="slide-img" />
    )
}
